import { Button, Typography, Dialog, DialogContent, DialogActions, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StockCountCreateContext, StockCountCreateValues } from '../../contexts/StockCountCreateContext';
import { useContext } from 'react';
import { CloseDialogAction } from '../../../../components/shared/dialogs/CloseDialogAction';

const StockCountCreateDeleteCountZonesModal = () => {
  const { isCountZonesDeleteModalOpen,
    handleClose,
    deleteCountZones,
    countZonesData,
    countZoneId } = useContext(StockCountCreateContext) as StockCountCreateValues;

  const { t } = useTranslation('createStockCount');

  const handleConfirm = () => {
    if (countZoneId !== undefined) {
      const data = countZonesData?.filter(item => item.id !== countZoneId);
      deleteCountZones(data);
    }
    else {
      deleteCountZones([]);
    }
  };

  return (
    <Dialog open={isCountZonesDeleteModalOpen}
      onClose={handleClose}
      maxWidth='sm'
      fullWidth>
      <DialogTitle>
        {t('countZones.delete')}
        <CloseDialogAction onCancel={handleClose} />
      </DialogTitle>
      <DialogContent>
        <Typography>{t('countZones.deleteMessage')}</Typography>
      </DialogContent>
      <DialogActions >
        <Button
          variant="secondary"
          size='lg'
          onClick={handleClose}> {t('cancel')}</Button>
        <Button variant="bad"
          size='lg'
          onClick={handleConfirm}>
          {t('confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StockCountCreateDeleteCountZonesModal;